// account
export const SET_ACCOUNT = 'setAccount';
export const SET_ACCOUNT_ORGANIZATION = 'setAccountOrganization';
export const SET_SESSION_TOKEN = 'setToken';

// fayda
export const SET_FAYDA = 'setFayda';
export const SET_FAYDA_USER_INFO = 'setFaydaUserInfo';

// organization
export const SET_ORGANIZATION = 'setOrganization';
export const SET_ORGANIZATIONS = 'setOrganizations';

// employees
export const SET_EMPLOYEE = 'setEmployee';
export const SET_EMPLOYEES = 'setEmployees';
export const SET_EMPLOYEE_STATS = 'setEmployeeStats';
export const SET_EMPLOYEE_DIRECTORY = 'setEmployeeDirectory';
export const SET_EMPLOYEE_ACTIVITY = 'setEmployeeActivity';

// employee_address
export const SET_EMPLOYEE_ADDRESS = 'setEmployeeAddress';
export const SET_EMPLOYEE_ADDRESSES = 'setEmployeeAddresses';

// employee_position
export const SET_EMPLOYEE_POSITION = 'setEmployeePosition';
export const SET_EMPLOYEE_POSITIONS = 'setEmployeePositions';

// employee_salary
export const SET_EMPLOYEE_SALARY = 'setEmployeeSalary';
export const SET_EMPLOYEE_SALARIES = 'setEmployeeSalaries';

// employee_salary
export const SET_EMPLOYEE_SALARY_PROMOTION = 'setEmployeeSalaryPromotion';
export const SET_EMPLOYEE_SALARY_PROMOTIONS = 'setEmployeeSalaryPromotions';

// employee_bank
export const SET_EMPLOYEE_BANK = 'setEmployeeBank';
export const SET_EMPLOYEE_BANKS = 'setEmployeeBanks';

// employee_education
export const SET_EMPLOYEE_EDUCATION = 'setEmployeeEducation';
export const SET_EMPLOYEE_EDUCATIONS = 'setEmployeeEducations';

// employee_leave
export const SET_EMPLOYEE_LEAVE = 'setEmployeeLeave';
export const SET_EMPLOYEE_LEAVES = 'setEmployeeLeaves';

// employee_payroll
export const SET_EMPLOYEE_PAYROLL = 'setEmployeePayroll';
export const SET_EMPLOYEE_PAYROLLS = 'setEmployeePayrolls';
export const SET_EMPLOYEE_PAYROLL_STATS = 'setEmployeePayrollWithStats';

// employee_payroll
export const SET_EMPLOYEE_ALLOWANCE = 'setEmployeeAllowance';
export const SET_EMPLOYEE_ALLOWANCES = 'setEmployeeAllowances';

// employee_overtime
export const SET_EMPLOYEE_OVERTIME = 'setEmployeeOvertime';
export const SET_EMPLOYEE_OVERTIMES = 'setEmployeeOvertimes';
export const SET_EMPLOYEE_OVERTIMES_BY_EMPLOYEE = 'setEmployeeOvertimesByEmployee';
export const SET_OVERTIME_ANALYTICS = 'setOvertimeAnalytics';

// employee_overtime
export const SET_EMPLOYEE_CONTRACT = 'setEmployeeContract';
export const SET_EMPLOYEE_CONTRACTS = 'setEmployeeContracts';

// department
export const SET_DEPARTMENT = 'setDepartment';
export const SET_ORGANIZATIONAL_DEPARTMENT = 'setOrganizationalDepartment';
export const SET_DEPARTMENTS = 'setDepartments';

// position
export const SET_POSITION = 'setPosition';
export const SET_POSITIONS = 'setPositions';

// bank
export const SET_BANK = 'setBank';
export const SET_BANKS = 'setBanks';

// payroll_period
export const SET_PAYROLL_PERIOD = 'setPayrollPeriod';
export const SET_PAYROLL_PERIODS = 'setPayrollPeriods';

// payroll
export const SET_PAYROLL = 'setPayroll';
export const SET_PAYROLLS = 'setPayrolls';
export const SET_PAYROLL_STATS_CHART = 'setPayrollStatsChart';
export const SET_EMPLOYEES_WITHOUT_SALARY = 'setEmployeesWithoutSalary';
export const SET_EMPLOYEES_WITH_SALARY = 'setEmployeesWithSalary';
export const SET_PAYROLL_COMPENSATION = 'setPayrollCompensation';
export const SET_PAYROLL_ANALYTICS = 'setPayrollAnalytics';
export const SET_PAYROLL_EMPLOYEE_ANALYTICS = 'setPayrollEmployeeAnalytics';
export const SET_PAYROLL_EXPORT = 'setPayrollExport';

// leave_type
export const SET_LEAVE_TYPE = 'setLeaveType';
export const SET_LEAVE_TYPES = 'setLeaveTypes';

// leave_request
export const SET_LEAVE_REQUEST = 'setLeaveRequest';
export const SET_LEAVE_REQUESTS = 'setLeaveRequests';
export const SET_LEAVE_STATS = 'setLeaveStats';

// leave_balance
export const SET_LEAVE_BALANCE = 'setLeaveBalance';
export const SET_LEAVE_BALANCES = 'setLeaveBalances';

// leave_ledger
export const SET_LEAVE_LEDGER = 'setLeaveLedger';
export const SET_LEAVE_LEDGERS = 'setLeaveLedgers';

// overtime_setting
export const SET_OVERTIME_SETTING = 'setOvertimeSetting';
export const SET_OVERTIME_SETTINGS = 'setOvertimeSettings';

// allowance_type
export const SET_ALLOWANCE_TYPE = 'setAllowanceType';
export const SET_ALLOWANCE_TYPES = 'setAllowanceTypes';

// holiday
export const SET_CALENDAR_HOLIDAY = 'setCalendarHoliday';
export const SET_CALENDAR_HOLIDAYS = 'setCalendarHolidays';
export const SET_HOLIDAY = 'setHoliday';
export const SET_HOLIDAYS = 'setHolidays';

// attendance_log
export const SET_ATTENDANCE_LOG = 'setAttendanceLog';
export const SET_ATTENDANCE_LOGS = 'setAttendanceLogs';
export const SET_ATTENDANCE_REPORT = 'setAttendanceReport';
export const SET_CALENDAR_ATTENDANCE_LOGS = 'setCalendarAttendanceLogs';
export const SET_USER_ATTENDANCE_LOGS = 'setUserAttendanceLogs';
export const SET_USER_ATTENDANCE_DAYS = 'setUserAttendanceDays';
export const SET_ATTENDANCE_ANALYTICS = 'setAttendanceAnalytics';
export const SET_ATTENDANCE_DAY_RECORDS = 'setAttendanceDayRecords';
export const SET_ATTENDANCE_EXPORT = 'setAttendanceExport';

// drive (the Files module)
export const SET_DRIVE_TREE = 'setDriveTree';
export const SET_DRIVE_BROWSE = 'setDriveBrowse';
export const SET_DRIVE_USAGE = 'setDriveUsage';
export const SET_DRIVE_MUTATION = 'setDriveMutation';

// attendance_schedule
export const SET_ATTENDANCE_SCHEDULE = 'setAttendanceSchedule';
export const SET_ATTENDANCE_SCHEDULES = 'setAttendanceSchedules';

// attendance_shift
export const SET_ATTENDANCE_SHIFT = 'setAttendanceShift';
export const SET_ATTENDANCE_SHIFTS = 'setAttendanceShifts';

// employee_attendance_shift
export const SET_EMPLOYEE_ATTENDANCE_SHIFT = 'setEmployeeAttendanceShift';
export const SET_EMPLOYEE_ATTENDANCE_SHIFTS = 'setEmployeeAttendanceShifts';

// file
export const SET_FILE = 'setFile';
export const SET_FILES = 'setFiles';

// payroll_component
export const SET_PAYROLL_COMPONENT = 'setPayrollComponent';
export const SET_PAYROLL_COMPONENTS = 'setPayrollComponents';

// employee_payroll_component
export const SET_EMPLOYEE_PAYROLL_COMPONENT = 'setEmployeePayrollComponent';
export const SET_EMPLOYEE_PAYROLL_COMPONENTS = 'setEmployeePayrollComponents';

// guideline
export const SET_GUIDELINE = 'setGuideline';
export const SET_GUIDELINES = 'setGuidelines';

// job_application
export const SET_JOB_APPLICATION = 'setJobApplication';
export const SET_JOB_APPLICATIONS = 'setJobApplications';
export const SET_JOB_APPLICATION_STATS = 'setJobApplicationStats';

// job_post
export const SET_JOB_POST = 'setJobPost';
export const SET_JOB_POSTS = 'setJobPosts';

// stats
export const SET_DASHBOARD_STATS = 'setDashboardStats';
export const SET_EMPLOYEE_DASHBOARD_STATS = 'setEmployeeDashboardStats';
export const SET_ADMIN_DASHBOARD_STATS = 'setAdminDashboardStats';

// reports
export const SET_EMPLOYEE_REPORTS = 'setEmployeeReports';
export const SET_PAYROLL_REPORTS = 'setPayrollReports';
export const SET_PROJECT_REPORTS = 'setProjectReports';
export const SET_REPORT_FACETS = 'setReportFacets';
export const SET_REPORT_RESULT = 'setReportResult';
export const SET_REPORT_EXPORT = 'setReportExport';

// project
export const SET_PROJECT = 'setProject';
export const SET_PROJECTS = 'setProjects';

// client
export const SET_CLIENT = 'setClient';
export const SET_CLIENTS = 'setClients';

// billing_invoicing
export const SET_BILLING_AND_INVOICING = 'setBillingInvoicing';
export const SET_BILLING_AND_INVOICINGS = 'setBillingInvoicings';
export const SET_BILLING_AND_INVOICING_STATS = 'setBillingInvoicingStats';

// invoice_item
export const SET_INVOICE_ITEM = 'setInvoiceItem';
export const SET_INVOICE_ITEMS = 'setInvoiceItems';

// milestone
export const SET_MILESTONE = 'setMilestone';
export const SET_MILESTONES = 'setMilestones';

// project_employee
export const SET_PROJECT_EMPLOYEE = 'setProjectEmployee';
export const SET_PROJECT_EMPLOYEES = 'setProjectEmployees';

// project_transaction
export const SET_PROJECT_TRANSACTION = 'setProjectTransaction';
export const SET_PROJECT_TRANSACTIONS = 'setProjectTransactions';
export const SET_PROJECT_TRANSACTION_STATS = 'setProjectTransactionStats';

// project_file
export const SET_PROJECT_FILE = 'setProjectFile';
export const SET_PROJECT_FILES = 'setProjectFiles';

// project_employee_role
export const SET_PROJECT_EMPLOYEE_ROLE = 'setProjectEmployeeRole';
export const SET_PROJECT_EMPLOYEE_ROLES = 'setProjectEmployeeRoles';

// employee_offboarding
export const SET_EMPLOYEE_OFFBOARDING = 'setEmployeeOffboarding';
export const SET_EMPLOYEE_OFFBOARDINGS = 'setEmployeeOffboardings';

// employee_offboarding_checklist
export const SET_EMPLOYEE_OFFBOARDING_CHECKLIST = 'setEmployeeOffboardingChecklist';

// employee_offboarding_template
export const SET_EMPLOYEE_OFFBOARDING_TEMPLATE = 'setEmployeeOffboardingTemplate';
export const SET_EMPLOYEE_OFFBOARDING_TEMPLATES = 'setEmployeeOffboardingTemplates';

// router_loader
export const SET_ROUTER_LOADER = 'setRouterLoader';

// export_template
export const SET_EXPORT_TEMPLATE = 'setExportTemplate';
export const SET_EXPORT_TEMPLATES = 'setExportTemplates';
export const SET_EXPORT_DATASETS = 'setExportDatasets';
export const SET_EXPORT_DATASET_FIELDS = 'setExportDatasetFields';
export const SET_EXPORT_RUN = 'setExportRun';

// knowledge_base_category
export const SET_KNOWLEDGE_BASE_CATEGORY = 'setKnowledgeBaseCategory';
export const SET_KNOWLEDGE_BASE_CATEGORIES = 'setKnowledgeBaseCategories';

// knowledge_base_article
export const SET_KNOWLEDGE_BASE_ARTICLE = 'setKnowledgeBaseArticle';
export const SET_KNOWLEDGE_BASE_ARTICLES = 'setKnowledgeBaseArticles';

// error
export const SET_ERRORMSG = 'setErrorMsg';

// chat
export const SET_CHAT_CONVERSATIONS = 'setChatConversations';
export const UPSERT_CHAT_CONVERSATION = 'upsertChatConversation';
export const PATCH_CHAT_CONVERSATION = 'patchChatConversation';
export const REMOVE_CHAT_CONVERSATION = 'removeChatConversation';
export const SET_CHAT_MESSAGES = 'setChatMessages';
export const PREPEND_CHAT_MESSAGES = 'prependChatMessages';
export const APPEND_CHAT_MESSAGE = 'appendChatMessage';
export const PATCH_CHAT_MESSAGE = 'patchChatMessage';
export const REMOVE_CHAT_MESSAGE = 'removeChatMessage';
export const SET_CHAT_MESSAGES_LOADING = 'setChatMessagesLoading';
export const SET_CHAT_DIRECTORY = 'setChatDirectory';
export const SET_CHAT_NOTIFICATIONS = 'setChatNotifications';
export const UPSERT_CHAT_NOTIFICATION = 'upsertChatNotification';
export const SET_CHAT_NOTIFICATION_COUNTS = 'setChatNotificationCounts';
export const MARK_CHAT_NOTIFICATIONS = 'markChatNotifications';
export const SET_CHAT_PRESENCE = 'setChatPresence';
export const SET_CHAT_TYPING = 'setChatTyping';
export const SET_CHAT_MEMBER_READ = 'setChatMemberRead';
export const SET_CHAT_SOCKET = 'setChatSocket';
export const SET_CHAT_ACTIVE = 'setChatActive';
export const SET_CHAT_SUMMARY = 'setChatSummary';
export const SET_CHAT_LOADING = 'setChatLoading';
export const RESET_CHAT = 'resetChat';
